import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../Table.css';
import DashboardLayout from '../Sidebar/DashboardLayout'; 
import ActionButtons from '../../commun/ActionButtons';
import ModalButton from '../../commun/ModalButton';
import TableFilterControls from '../../commun/TableFilterControls';
import FormInputMUI from '../../commun/FormInputMUI';
import useMessages from '../../../hooks/useMessages';
import { showDeleteConfirmation } from '../../commun/deletemsg';
import { generateRandomPassword } from '../../commun/generatepwd';
import GenericTable from '../../commun/GenericTable';
import Pagination from '../../commun/Pagination';
import FormField from '../../Recruteur/candidat/AddTalent/FormField';
import CustomAlert from '../../commun/CustomAlert';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { useNavigate } from 'react-router-dom';
import Chatbox from '../../commun/ChatBox';

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const RecruteursDashboard = () => {
  const [displayMode, setDisplayMode] = useState('table');
  const [page, setPage] = useState(1);
  const [recruteurs, setRecruteurs] = useState([]);
  const [editingRecruteursId, setEditingRecruteursId] = useState(null);
  const [showPassword, setShowPassword] = useState(false)
  const navigate = useNavigate();
  const [selectedRows, setSelectedRows] = useState([]);
  const userRole = localStorage.getItem('userType');
  const recruteurPerPage = 5 ;
  const handleGenerate = () => {
      const randomPwd = generateRandomPassword();
      setFormData(prev => ({ ...prev, motDePasse: randomPwd }));
    };
  const [editFormData, setEditFormData] = useState({
    id: null,
    name: '',
    phone: '',
    email: '',
  });
   const resetForm = () => {
    setFormData({
      lastName: "",
      firstName: "",
      email: "",
      phone: "",
      linkedin: "",
      cguAccepted: false,
      motDePasse: "",
      verificationCode: "",
    });
    setErrors({});
    handleSuccess(""); 
    handleError("");
  };
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
useEffect(() => {
  const fetchRecruteursWithCandidatureCounts = async () => {
    try {
      const response = await axios.get(`${API_BASE}/api/auth/recruteurs`);

      const recruteursData = await Promise.all(
        response.data
          .filter((r) => r.utilisateur !== null)
          .map(async (recruteur) => {
            const [candidaturesRes, statsRes] = await Promise.all([
              axios.get(`${API_BASE}/api/candidatures/recruteur-reussite/count`, {
                params: { userId: recruteur.utilisateur._id },
              }),
              axios.get(`${API_BASE}/api/recruteur/stats/${recruteur.utilisateur._id}`),
            ]);

            return {
              ...recruteur,
              nbrcandidatreussites: candidaturesRes.data.count || 0,
              niveau: statsRes.data.niveau?.label || "Débutant",
              primeTotale: statsRes.data.primeTotale || 0,
            };
          })
      );

      setRecruteurs(recruteursData); 
    } catch (error) {
      setAlertMessage("Erreur lors de la récupération des recruteurs");
      setAlertSeverity("error");
      setAlertOpen(true);
    }
  };

  fetchRecruteursWithCandidatureCounts();
}, []);

  
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertSeverity, setAlertSeverity] = useState('success');


  const filteredRecruteurs = recruteurs.filter((recruteur) => {
    const utilisateur = recruteur.utilisateur;
    if (!utilisateur) return false;
    const matchesSearch = (recruteur.utilisateur.firstName + " " + recruteur.utilisateur.lastName).toLowerCase().includes(searchTerm.toLowerCase()); // Concatenate firstName and lastName
    const matchesStatus = statusFilter ? utilisateur.statut === statusFilter : true;
    return matchesSearch && matchesStatus;
  });
  
  const paginatedData = filteredRecruteurs.slice((page - 1) * recruteurPerPage, page * recruteurPerPage);
const columns = [
{
  key: 'niveau',
  label: 'Niveau',
  render: (value, row) => {
    const niveauLabel = (row.niveau || 'Débutant').toLowerCase();
    const cssClass = {
      débutant: 'niveau-debutant',
      intermédiaire: 'niveau-intermediaire',
      confirmé: 'niveau-confirme',
      expert: 'niveau-expert',
      légende: 'niveau-legende'
    }[niveauLabel] || 'niveau-debutant';

    return (
      <span className={`niveau-pill ${cssClass}`}>
        {row.niveau || 'Débutant'}
      </span>
    );
  }
},

  {
    key: 'name',
    label: 'Nom Recruteur',
    render: (value, row) =>
      editingRecruteursId === row._id ? (
        <input
          type="text"
          name="name"
          value={`${editFormData.firstName} ${editFormData.lastName}`}
          onChange={handleEditFormChange}
        />
      ) : (
        `${row.utilisateur.firstName} ${row.utilisateur.lastName}`
      )
  },
  {
    key: 'phone',
    label: 'Téléphone',
    render: (value, row) =>
      editingRecruteursId === row._id ? (
        <input
          type="text"
          name="phone"
          value={editFormData.phone}
          onChange={handleEditFormChange}
        />
      ) : (
        <a href={`tel:${row.utilisateur.phone}`} className="link-action">{row.utilisateur.phone}</a> 
      )
  },
  {
    key: 'email',
    label: 'Email',
    render: (value, row) =>
      editingRecruteursId === row._id ? (
        <input
          type="email"
          name="email"
          value={editFormData.email}
          onChange={handleEditFormChange}
        />
      ) : (
        <a href={`mailto:${row.utilisateur.email}`} className="link-action">{row.utilisateur.email}</a> 
      )
  },
  {
    key: 'nbrcandidatreussites',
    label: 'Candidatures réussites',
    render: (value, row) => <span>{row.nbrcandidatreussites}</span>
  },
  {
    key: 'primeTotale',
    label: 'Primes',
    render: (value, row) => <span>{row.primeTotale} €</span>
  },
  {
    key: 'statut',
    label: 'Statut',
    render: (value, row) => (
      <div
        className={row.utilisateur.statut === 'active' ? 'statusActive' : 'statusInactive'}
        onClick={() => handleToggleStatus(row._id)}
        style={{ cursor: 'pointer' }}
      >
        {row.utilisateur.statut === 'active' ? 'Active' : 'Inactive'}
      </div>
    )
  }
];

  
  const handleEdit = (RecruteursId) => {
    const RecruteursToEdit = recruteurs.find((Recruteurs) => Recruteurs._id === RecruteursId);
    setEditingRecruteursId(RecruteursId);
    setEditFormData({
      id: RecruteursToEdit.utilisateur._id,
      firstName: RecruteursToEdit.utilisateur.firstName || '',  
      lastName: RecruteursToEdit.utilisateur.lastName || '',    
      phone: RecruteursToEdit.utilisateur.phone || '',          
      email: RecruteursToEdit.utilisateur.email || '',          
    });
  };

  const handleEditFormChange = (event) => {
    const { name, value } = event.target;
    
    setEditFormData((prevState) => {
      let newState = { ...prevState };
      
      if (name === 'name') {
        const [firstName, lastName] = value.split(' ');
        newState.firstName = firstName || '';  
        newState.lastName = lastName || '';    
      } else {
        newState[name] = value;
      }
      
      return newState;
    });
  };

  const handleSaveEdit = async () => {
    try {
      const response = await axios.patch(`${API_BASE}/api/recruteur/edit/${editFormData.id}`, {
        utilisateur: {
          id : editFormData.id ,
          firstName: editFormData.firstName,
          lastName: editFormData.lastName,
          email: editFormData.email,
          phone: editFormData.phone,
        }
      });      
  
       const updatedRecruteur = response.data.recruteur;
  
       const updatedRecruteurs = recruteurs.map((recruteur) =>
        recruteur._id === updatedRecruteur._id ? updatedRecruteur : recruteur
      );
      setRecruteurs(updatedRecruteurs);
      setEditingRecruteursId(null);
    } catch (error) {
      setAlertMessage("Erreur lors de l'enregistrement de la modification du recruteur ", error);
      setAlertSeverity("error");
      setAlertOpen(true);
    }
  };

  const handleCancelEdit = () => {
    setEditingRecruteursId(null);
  };

  const handleToggleStatus = async (recruteurId) => {
    const recruteurToUpdate = recruteurs.find(recruteur => recruteur._id === recruteurId);
    if (!recruteurToUpdate) {
      setAlertMessage("Recruteur non trouvé !");
      setAlertSeverity("error");
      setAlertOpen(true);
      return;
    }
    const updatedStatus = recruteurToUpdate.utilisateur.statut === 'active' ? 'inactive' : 'active';
    const updatedRecruteur = { 
      ...recruteurToUpdate,
      utilisateur: {
        ...recruteurToUpdate.utilisateur,
        statut: updatedStatus
      }
    };
    const updatedRecruteurs = recruteurs.map((recruteur) =>
      recruteur._id === recruteurId ? updatedRecruteur : recruteur
    );
    setRecruteurs(updatedRecruteurs);
  
    try {
      const utilisateurId = recruteurToUpdate.utilisateur._id;
      await axios.patch(`${API_BASE}/api/recruteur/update-status/${utilisateurId}`, {
        statut: updatedStatus,
      });
  
      setAlertMessage("Veuillez corriger les erreurs dans le formulaire.");
      setAlertSeverity("succees");
      setAlertOpen(true);
    } catch (error) {
      setAlertMessage("Échec de la mise à jour du statut dans la base de données :", error);
      setAlertSeverity("error");
      setAlertOpen(true);
    }
  };
  
  const handleDelete = async (RecruteursId) => {
    showDeleteConfirmation({
      onConfirm: async () => {
      try {
          await axios.delete(`${API_BASE}/api/recruteur/delete/${RecruteursId}`);
          const updatedRecruteurs = recruteurs.filter((Recruteurs) => Recruteurs._id !== RecruteursId);
          setRecruteurs(updatedRecruteurs); 
      } catch (error) {
          setAlertMessage('Error deleting recruteur:', error);
          setAlertSeverity("error");
          setAlertOpen(true);
      }
        },
        onCancel: () => {
            setAlertMessage("Suppression annulée");
            setAlertSeverity("error");
            setAlertOpen(true);
        }
    });
};

   const [showModal , setShowModal] = useState();
    const handleClose = () => setShowModal(false);
    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState({
        lastName: "",
        firstName: "",
        email: "",
        phone: "",
        linkedin: "",
        cguAccepted: false,
        motDePasse: "",
        verificationCode: "", 
      });
      const handleInputChange = (name, value) => {
        setFormData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
      };

      const handleSubmit = async (e) => {
        e.preventDefault();
    
        if (!validateForm()) {
            handleError("Veuillez remplir tous les champs obligatoires.");
            return;
        }
    
        try {
            const response = await fetch(`${API_BASE}/api/auth/admin/add-recruteur`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    ...formData,
                    isAdminSignup: true,
                }),
            });
            const data = await response.json();
            if (!response.ok) {
              const { code, message } = data;
              if (response.status === 409 && code === "EMAIL_ALREADY_EXISTS") {
                  setAlertMessage("Cet email est déjà utilisé. Veuillez en choisir un autre.");
                  setAlertSeverity("error");
                  setAlertOpen(true);
                  return;
              }
              throw new Error(message || "Une erreur est survenue.");
          }          
            const updatedResponse = await fetch(`${API_BASE}/api/auth/recruteurs`);
            const updatedList = await updatedResponse.json();
            setRecruteurs(updatedList);        
            setAlertMessage("Inscription réussie ! Un email contenant votre mot de passe et vos coordonnées a été envoyé.");
            setAlertSeverity("success");
            setAlertOpen(true);
            setTimeout(() => {
                setShowModal(false);
            }, 2000);
            setTimeout(() => {
                resetForm();
            }, 3000);
    
        } catch (error) {
          if (error.response?.status === 409) {
            setAlertMessage('Un utilisateur avec cet email existe déjà.');
            setAlertSeverity("error");
            setAlertOpen(true);
          }else {
            const errMsg =
              error?.response?.data?.errors?.phone?.message ||
              error?.response?.data?.message ||
              error.message;
            setAlertMessage(errMsg);
            setAlertSeverity("error");
            setAlertOpen(true);
          }
        }
    };
    
    
      const validateForm = () => {
        const newErrors = {};
        if (!formData.lastName.trim()) newErrors.lastName = "Ce champ est requis.";
        if (!formData.firstName.trim()) newErrors.firstName = "Ce champ est requis.";
        if (!formData.email.trim()) {
          newErrors.email = "Ce champ est requis.";
        } else if (!validateEmail(formData.email)) {
          newErrors.email = "Email invalide.";
        }
    
        if (!formData.phone.trim()) {
          newErrors.phone = "Ce champ est requis.";
        } else if (!validatePhone(formData.phone)) {
          newErrors.phone = "Numéro de téléphone invalide.";
        }
    
        if (!formData.motDePasse.trim()) {
          newErrors.motDePasse = "Le mot de passe est requis.";
        } else if (!validatePassword(formData.motDePasse)) {
          newErrors.motDePasse = "Le mot de passe doit comporter au moins 8 caractères.";
        }    
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
      };
        // Validation des champs du formulaire
      const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
      };

      const validatePhone = (phone) => /^\+?[0-9]{10,}$/.test(phone);

      const validatePassword = (password) => {
        return password.length >= 8; 
      };

      const { messages, handleSuccess, handleError } = useMessages();
      
  return (
    <section className="dashboardContainer">
      <div className="headerTalentWrapper">
      <h3 className="componentTitle">Les Recruteurs </h3>
      <div className="top-controlsC">
      <ModalButton onClick={() => setShowModal(true)} />

      <TableFilterControls
          searchValue={searchTerm}
          onSearchChange={setSearchTerm}
          statusValue={statusFilter}
          onStatusChange={setStatusFilter}
        />
        </div>
        </div>
      {showModal && (
          <div className="modal-overlay" onClick={() => { handleClose(); resetForm(); }}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <h2>Formulaire d'ajout</h2>
              <CustomAlert
                open={alertOpen}
                message={alertMessage}
                severity={alertSeverity}
                onClose={() => setAlertOpen(false)}
              />
              <form onSubmit={handleSubmit} className="application-form">
                <FormInputMUI
                  label="Nom *"
                  value={formData.lastName}
                  onChange={(value) => handleInputChange("lastName", value)}
                  error={errors.lastName}
                />
                <FormInputMUI
                  label="Prénom *"
                  value={formData.firstName}
                  onChange={(value) => handleInputChange("firstName", value)}
                  error={errors.firstName}
                />

                <FormInputMUI
                  label="Email *"
                  type="email"
                  value={formData.email}
                  onChange={(value) => handleInputChange("email", value)}
                  error={errors.email}
                />

              <div className="phone-user">
                <FormField
                  type="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={(e) => handleInputChange(e.target.name, e.target.value)}
                  error={errors.phone}
                />
               </div>
                <FormInputMUI
                  label="LinkedIn"
                  value={formData.linkedin}
                  onChange={(value) => handleInputChange("linkedin", value)}
                />

                <div className="password-field-wrapper">
                  <TextField
                  label="Mot de passe *"
                  type={showPassword ? 'text' : 'password'}
                  value={formData.motDePasse}
                  onChange={(e) => handleInputChange("motDePasse", e.target.value)}
                  error={!!errors.motDePasse}
                  helperText={errors.motDePasse}
                  fullWidth
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPassword((prev) => !prev)}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  variant="outlined"
                  size="small"
                />
                  <button
                    type="button"
                    className="generate-password-button"
                    onClick={handleGenerate}
                  >
                    Générer
                  </button>
                </div>

                <div className="form-rowcheck"> 
                  <div className="form-group">
                    <label className="form-label checkbox-label">
                      <input
                        type="checkbox"
                        checked={formData.cguAccepted}
                        onChange={(e) => handleInputChange("cguAccepted", e.target.checked)}
                      />
                      {" "}J'accepte les <a href="/cgu" target="_blank">CGU</a> *
                    </label>
                    {errors.cguAccepted && <p className="error-text">{errors.cguAccepted}</p>}
                  </div>
                  <div className="button-container">
                    <button type="submit" className="submit-button">
                      Confirmer
                    </button>
                  </div>
                </div>
              </form>

                          </div>
                        </div>
                      )}
              <GenericTable
              displayMode={displayMode}
               setDisplayMode={setDisplayMode}
                columns={columns}
                data={paginatedData}
                totalItems={recruteurs.length}
                renderActions={(row) => (
                  <ActionButtons
                    showEdit={false}
                    showView={true}
                    onView={() => navigate(`/admin/recruteur/${row.utilisateur._id}`)}
                    onDelete={() => handleDelete(row._id)}
                  />
                )}
                selectedRows={selectedRows}
                setSelectedRows={setSelectedRows}
              />

                    <Pagination page={page} setPage={setPage} totalItems={filteredRecruteurs.length} itemsPerPage={recruteurPerPage} />
                                          {userRole !== 'agent' && <Chatbox userRole={userRole} />}

                  </section>

                );
              };

              const Recruteurs = () => (
                <DashboardLayout>
                  <RecruteursDashboard />
                </DashboardLayout>
              );


export default Recruteurs;
